import * as React from 'react';
import { Button } from 'kui';
import { IEssentialUpgradeButtonProps } from './types';
import './_EssentialUpgradeButton.scss';
import { ESSENTIAL_UPGRADE_BUTTON_LABEl, CLASS_ESSENTIAL_UPGRADE_BUTTON, } from './constants';

export const EssentialUpgradeButton = ({
    onUpgrade
}: IEssentialUpgradeButtonProps) => (
    <Button
        className={CLASS_ESSENTIAL_UPGRADE_BUTTON}
        variant={'primary'}
        onClick={onUpgrade}
    >
        {ESSENTIAL_UPGRADE_BUTTON_LABEl}
    </Button>
);
